import Link from 'next/link';

import Refresh from '~components/Icon/Refresh';

import { useGetSlicedList } from './hooks';
import * as S from './style';

type Company = {
  CMPN_NM: string;
  PK_NM_HASH: string;
};

export default function RealTime() {
  const { slicedList, refetch } = useGetSlicedList();

  return (
    <S.RealTimeWrapper>
      <dt>
        실시간
        <button type='button' onClick={() => refetch()}>
          <Refresh />
        </button>
      </dt>
      <dd>
        <ul>
          {slicedList.map((data: Company, index: number) => (
            <li key={index}>
              <Link href={`/company/${data.PK_NM_HASH}`} title={decodeURI(data['CMPN_NM'])}>
                <a
                  data-attribute-id='company__search__click'
                  data-search-type='실시간검색'
                  data-search-value={data['CMPN_NM']}>
                  {decodeURI(data['CMPN_NM'])}
                </a>
              </Link>
            </li>
          ))}
        </ul>
      </dd>
    </S.RealTimeWrapper>
  );
}
